import { FeatureFlag } from '../FeatureFlag';

export const enableCsvOrderUpload = new FeatureFlag({
    key: 'enable-csv-order-upload',
    defaultValue: false,
});
